import f from "./ghl-ui.es728.js";
import t from "./ghl-ui.es765.js";
var r = typeof exports == "object" && exports && !exports.nodeType && exports, e = r && typeof module == "object" && module && !module.nodeType && module, u = e && e.exports === r, o = u ? f.Buffer : void 0, s = o ? o.isBuffer : void 0, p = s || t;
const m = p;
export {
  m as default
};
